import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, ExternalLink } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

export default function GoogleReviewsWidget() {
  const { t } = useTranslation();
  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.2 },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <motion.div variants={item} className="flex items-center justify-center gap-2 mb-4">
            <MapPin className="h-6 w-6 text-blue-600" />
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              {t('reviews.title')}
            </h2>
          </motion.div>
          
          <motion.p variants={item} className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('reviews.subtitle')}
          </motion.p>
        </motion.div>

        {/* Elfsight Google Reviews Widget */}
        <div className="mb-12">
          <div className="elfsight-app-a8b2a68e-b08c-4145-b01d-dc81edca38f3" data-elfsight-app-lazy></div>
        </div>

        <motion.div
          variants={item}
          className="text-center"
        >
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">
              {t('reviews.leave_review')}
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              {t('reviews.leave_review_desc')}
            </p>
            <a
              href="https://www.google.com/maps/place/?q=place_id:EitIZWJlbHN0cmHDn2UgMjcsIDc5MzEyIEVtbWVuZGluZ2VuLCBHZXJtYW55IjASLgoUChIJe72FyJkYkUcRs0PTHGwHMeUQGyoUChIJzyJl7JkYkUcRoaqm-zLcnCw"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-xl transition-colors"
            >
{t('reviews.leave_review_google')}
              <ExternalLink className="h-4 w-4" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
